<template>
  <v-data-table
    :headers="headers"
    :items="value"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
    class="elevation-1"
  >
    <template v-slot:top></template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="px-0">
        <synop-measurement-table v-model="item.items" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import SynopMeasurementTable from "./SynopMeasurementTable.vue";
export default {
  name: "SynopMeasurement",
  components: {
    SynopMeasurementTable
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      expanded: [],
      singleExpand: false,
      groupBy: true,
      headers: [
        {
          text: "Индекс станции",
          align: "start",
          sortable: false,
          value: "index"
        },
        { text: "Время наблюдения", value: "obs_time" },
        { text: "id", value: "id" }
      ]
    };
  }
};
</script>